<script lang="ts">
  export let mode: "exercise" | "task" = "exercise";
</script>

{#if mode === "exercise"}
  <div class={`${$$props.class} w-full h-sep bg-grey-300`} />
{:else}
  <div class={`${$$props.class} w-3/4 h-sep bg-grey-300`} />
{/if}
